import { render, staticRenderFns } from "./endrosmentPremium.vue?vue&type=template&id=683eefbe&scoped=true&"
import script from "./endrosmentPremium.vue?vue&type=script&lang=js&"
export * from "./endrosmentPremium.vue?vue&type=script&lang=js&"
import style0 from "./endrosmentPremium.vue?vue&type=style&index=0&id=683eefbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683eefbe",
  null
  
)

export default component.exports